@if (!loading) {
  <h1 class="pb-4">{{ content.demographicsHeadline }}</h1>
  @if (!isUk) {
    <form [formGroup]="demographicsForm">
      <div class="form-group">
        <strong>Where do you currently attend school?</strong>
        <div>
          <label for="question1answer1">
            <input type="radio" value="home-USA" id="question1answer1" formControlName="question1">
            US
          </label>
        </div>
        <div>
          <label for="question1answer2">
            <input type="radio" value="home-UK" id="question1answer2" formControlName="question1">
            UK
          </label>
        </div>
        <div>
          <label for="question1answer3">
            <input type="radio" value="home-other" id="question1answer3" formControlName="question1">
            Other
          </label>
        </div>
      </div>
      <div class="form-group">
        <strong>What are your priorities for improving as a student? (pick one)</strong>
        <div>
          <label for="question2answer1">
            <input type="radio" value="games-do the best i can" id="question2answer1" formControlName="question2">
            I just want to see how well I can do
          </label>
        </div>
        <div>
          <label for="question2answer2">
            <input type="radio" value="games-dream school" id="question2answer2" formControlName="question2">
            I need a particular score to get into my dream school
          </label>
        </div>
        <div>
          <label for="question2answer3">
            <input type="radio" value="games-recruitment" id="question2answer3" formControlName="question2">
            I'm trying to get recruited for a sport, art form, or other specialty
          </label>
        </div>
      </div>
      <div class="form-group">
        <strong>What is the biggest thing holding you back from doing your best? (pick one)</strong>
        <div>
          <label for="question3answer1">
            <input type="radio" value="games-Late Bloomer" id="question3answer1" formControlName="question3">
            I've never been a great student and I'm worried it's too late to start now
          </label>
        </div>
        <div>
          <label for="question3answer2">
            <input type="radio" value="games-Good Grades Bad ACT" id="question3answer2" formControlName="question3">
            I'm a really good student but I struggle with standardized tests
          </label>
        </div>
        <div>
          <label for="question3answer3">
            <input type="radio" value="games-Test Anxiety" id="question3answer3" formControlName="question3">
            I get too nervous and stressed out during big tests
          </label>
        </div>
        <div>
          <label for="question3answer4">
            <input type="radio" value="games-Bad at Math" id="question3answer4" formControlName="question3">
            I'm having a really hard time with math
          </label>
        </div>
        <div>
          <label for="question3answer5">
            <input type="radio" value="games-no avatar" id="question3answer5" formControlName="question3">
            None of these really apply to me. I just want to do as well as I can.
          </label>
        </div>
      </div>
      <div class="form-group">
        <strong>Which subject do you feel you need the most help on? (pick one)</strong>
        <div>
          <label for="question4answer1">
            <input type="radio" value="games-English" id="question4answer1" formControlName="question4">
            English
          </label>
        </div>
        <div>
          <label for="question4answer2">
            <input type="radio" value="games-Math1" id="question4answer2" formControlName="question4">
            Math in general
          </label>
        </div>
        <div>
          <label for="question4answer3">
            <input type="radio" value="games-Math2" id="question4answer3" formControlName="question4">
            Advanced Math
          </label>
        </div>
        <div>
          <label for="question4answer4">
            <input type="radio" value="games-Reading" id="question4answer4" formControlName="question4">
            Reading
          </label>
        </div>
        <div>
          <label for="question4answer5">
            <input type="radio" value="games-Science" id="question4answer5" formControlName="question4">
            Science
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="shouldEmail">
          <input type="checkbox" formControlName="email" id="shouldEmail" class="mr-2">
          <strong>{{ content.practicePlanCheckbox }}</strong>
        </label>
      </div>
      <button class="btn btn-block btn-primary" (click)="submitForm()">Submit</button>
      <div class="mt-4 text-center">
        <a href="" (click)="logout()">Sign in with a different account</a>
      </div>
    </form>
  }
  @if (isUk) {
    <form [formGroup]="demographicsForm">
      <div class="form-group">
        <strong>What are your priorities for improving as a student? (pick one)</strong>
        <div>
          <label for="question2answer1">
            <input type="radio" value="games-do the best i can" id="question2answer1" formControlName="question2">
            I just want to see how well I can do
          </label>
        </div>
        <div>
          <label for="question2answer2">
            <input type="radio" value="before-assessment" id="question2answer2" formControlName="question2">
            I need to improve my test scores before my next assessment
          </label>
        </div>
        <div>
          <label for="question2answer3">
            <input type="radio" value="after-assessment" id="question2answer3" formControlName="question2">
            I scored poorly on my last assessment and want to catch up.
          </label>
        </div>
      </div>
      <div class="form-group">
        <strong>What is the biggest thing holding you back from doing your best? (pick one)</strong>
        <div>
          <label for="question3answer1">
            <input type="radio" value="games-Late Bloomer" id="question3answer1" formControlName="question3">
            I've never been a great student and I'm worried it's too late to start now
          </label>
        </div>
        <div>
          <label for="question3answer2">
            <input type="radio" value="games-Good Grades Bad ACT" id="question3answer2" formControlName="question3">
            I'm a really good student but I struggle with standardized tests
          </label>
        </div>
        <div>
          <label for="question3answer3">
            <input type="radio" value="games-Test Anxiety" id="question3answer3" formControlName="question3">
            I get too nervous and stressed out during big tests
          </label>
        </div>
        <div>
          <label for="question3answer4">
            <input type="radio" value="games-Bad at Math" id="question3answer4" formControlName="question3">
            I am having a really hard time with Maths
          </label>
        </div>
        <div>
          <label for="question3answer5">
            <input type="radio" value="games-no avatar" id="question3answer5" formControlName="question3">
            None of these really apply to me. I just want to do as well as I can.
          </label>
        </div>
      </div>
      <div class="form-group">
        <strong>Which subject do you feel you need the most help on? (pick one)</strong>
        <div>
          <label for="question4answer1">
            <input type="radio" value="games-English" id="question4answer1" formControlName="question4">
            English
          </label>
        </div>
        <div>
          <label for="question4answer2">
            <input type="radio" value="games-Math1" id="question4answer2" formControlName="question4">
            Maths in general
          </label>
        </div>
        <div>
          <label for="question4answer3">
            <input type="radio" value="games-Math2" id="question4answer3" formControlName="question4">
            Advanced Maths
          </label>
        </div>
        <div>
          <label for="question4answer4">
            <input type="radio" value="games-Reading" id="question4answer4" formControlName="question4">
            Reading
          </label>
        </div>
        <div>
          <label for="question4answer5">
            <input type="radio" value="games-Science" id="question4answer5" formControlName="question4">
            Science
          </label>
        </div>
      </div>
      <button class="btn btn-block btn-primary" (click)="submitForm()">Submit</button>
      <div class="mt-4 text-center">
        <a href="" (click)="logout()">Sign in with a different account</a>
      </div>
    </form>
  }
} @else {
  <div class="center-div">
    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
  </div>
}
<app-feedback></app-feedback>
